<template>
  <div class="return-process-page">
    <div class="page-header">
      <div class="back-btn" @click="goBack">{{ $t('wholesaler.AfterSalesReturnPage.line4_text') }}</div>
      <h1>{{ $t('wholesaler.AfterSalesReturnPage.line5_text') }}</h1>
      <div class="sub">{{ detail.afterSalesNo }}</div>
    </div>

    <div v-loading="loading" class="content">
      <!-- 售后概要 -->
      <div class="module">
        <div class="module-header"><span class="icon">📋</span><span class="title">{{ $t('wholesaler.AfterSalesReturnPage.line12_text') }}</span></div>
        <div class="module-body">
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesReturnPage.line14_text') }}</span><span class="value mono" style="color:#457b9d;">{{ detail.orderNo }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesReturnPage.line15_text') }}</span><span class="value">{{ schemeText(detail.resolutionType) }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesReturnPage.line16_text') }}</span><span class="value"><el-tag :type="statusTagType(detail.resolutionStatus)" size="small">{{ statusText(detail.resolutionStatus) }}</el-tag></span></div>
          <div class="row" v-if="detail.reviewNote"><span class="label">{{ $t('wholesaler.AfterSalesReturnPage.line17_text') }}</span><span class="value">{{ detail.reviewNote }}</span></div>
        </div>
      </div>

      <!-- 客户申请信息 -->
      <div class="module">
        <div class="module-header"><span class="icon">📝</span><span class="title">{{ $t('wholesaler.AfterSalesReturnPage.line23_text') }}</span></div>
        <div class="module-body">
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesReturnPage.line25_text') }}</span><span class="value">{{ reasonText(detail.reasonCode) }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesReturnPage.line26_text') }}</span><span class="value" style="text-align:right;max-width:200px;">{{ detail.reasonText }}</span></div>
        </div>
      </div>

      <!-- 客户凭证 -->
      <div v-if="evidenceList.length > 0" class="module">
        <div class="module-header"><span class="icon">📸</span><span class="title">{{ $t('wholesaler.AfterSalesReturnPage.line32_text') }}</span></div>
        <div class="module-body">
          <div class="evidence-grid">
            <el-image v-for="(url, i) in evidenceList" :key="i" :src="getImageUrl(url)" :preview-src-list="evidenceList" class="evidence-img" fit="cover"></el-image>
          </div>
        </div>
      </div>

      <!-- 退回商品清单 -->
      <div class="module" style="border:2px solid #fa8c16;">
        <div class="module-header" style="background:#fff7e6;color:#d46b08;">
          <span class="icon">📦</span><span class="title">{{ $t('wholesaler.AfterSalesReturnPage.line43_text') }}</span>
        </div>
        <div class="module-body">
          <div v-for="(item, idx) in returnItems" :key="idx" class="return-item-card">
            <div class="ri-header">
              <span class="ri-name">{{ item.productName }}</span>
              <span class="ri-qty">退回数量: {{ item.quantity }}</span>
            </div>
            <div class="ri-body">
              <!-- 处理方式选择 -->
              <div class="ri-disposition">
                <span class="ri-label">{{ $t('wholesaler.AfterSalesReturnPage.line54_text') }}</span>
                <el-radio-group v-model="item.disposition">
                  <el-radio label="RESTOCK">{{ $t('wholesaler.AfterSalesReturnPage.line56_text') }}</el-radio>
                  <el-radio label="SCRAP">{{ $t('wholesaler.AfterSalesReturnPage.line57_text') }}</el-radio>
                </el-radio-group>
              </div>
              <!-- 选择仓库（还回仓库时显示） -->
              <div v-if="item.disposition === 'RESTOCK'" class="ri-warehouse">
                <span class="ri-label">{{ $t('wholesaler.AfterSalesReturnPage.line62_text') }}</span>
                <el-select v-model="item.warehouseId" :placeholder="$t('wholesaler.AfterSalesReturnPage.line63_placeholder')" clearable size="small" style="width:180px;">
                  <el-option label="请选择仓库" :value="null" disabled style="color:#999;"></el-option>
                  <el-option
                    v-for="wh in warehouses"
                    :key="'wh-' + wh.id"
                    :label="wh.warehouseName + (wh.isDefault ? ' (默认)' : '')"
                    :value="wh.id"
                  ></el-option>
                </el-select>
              </div>
              <!-- 质检备注 -->
              <el-input
                v-model="item.note"
                type="textarea"
                :rows="1"
                :placeholder="$t('wholesaler.AfterSalesReturnPage.line78_placeholder')"
                style="margin-top:6px;"
              ></el-input>
            </div>
          </div>
        </div>
      </div>

      <!-- 处理汇总 -->
      <div class="module">
        <div class="module-header"><span class="icon">📊</span><span class="title">{{ $t('wholesaler.AfterSalesReturnPage.line88_text') }}</span></div>
        <div class="module-body">
          <div class="summary-grid">
            <div class="summary-item green">
              <div class="s-num">{{ restockCount }}</div>
              <div class="s-label">{{ $t('wholesaler.AfterSalesReturnPage.line93_text') }}</div>
            </div>
            <div class="summary-item red">
              <div class="s-num">{{ scrapCount }}</div>
              <div class="s-label">{{ $t('wholesaler.AfterSalesReturnPage.line97_text') }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 退款金额 -->
      <div class="module" style="border:2px solid #ff4d4f;">
        <div class="module-header" style="background:#fff2f0;color:#ff4d4f;">
          <span class="icon">💰</span><span class="title">{{ $t('wholesaler.AfterSalesReturnPage.line106_text') }}</span>
        </div>
        <div class="module-body">
          <div class="row">
            <span class="label">{{ $t('wholesaler.AfterSalesReturnPage.line110_text') }}</span>
            <span class="value">S$ {{ centsToAmount(detail.refundAmount) }}</span>
          </div>
          <div class="row" style="padding-top:8px;">
            <span class="label" style="font-weight:600;">{{ $t('wholesaler.AfterSalesReturnPage.line114_text') }}</span>
            <span class="value amount">S$ {{ centsToAmount(form.refundAmount) }}</span>
          </div>
          <div style="font-size:11px;color:#bbb;margin-top:4px;">{{ $t('wholesaler.AfterSalesReturnPage.line117_text') }}</div>
          <el-input-number
            v-model="form.refundAmount"
            :min="0"
            :max="maxRefundAmount"
            :step="100"
            :precision="0"
            size="small"
            style="margin-top:8px;width:100%;"
            :placeholder="$t('wholesaler.AfterSalesReturnPage.line126_placeholder')"
          ></el-input-number>
        </div>
      </div>

      <!-- 退款凭证 -->
      <div class="module">
        <div class="module-header"><span class="icon">📷</span><span class="title">{{ $t('wholesaler.AfterSalesReturnPage.line133_text') }}</span></div>
        <div class="module-body">
          <el-upload
            action="/api/files/upload-image"
            list-type="picture-card"
            :file-list="proofFileList"
            :on-success="handleProofUpload"
            :on-remove="handleProofRemove"
            :before-upload="beforeProofUpload"
            accept="image/*"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div style="font-size:11px;color:#bbb;margin-top:4px;">{{ $t('wholesaler.AfterSalesReturnPage.line146_text') }}</div>
        </div>
      </div>

      <!-- 退款备注 -->
      <div class="module">
        <div class="module-header"><span class="icon">📝</span><span class="title">{{ $t('wholesaler.AfterSalesReturnPage.line152_text') }}</span></div>
        <div class="module-body">
          <el-input v-model="form.refundNote" type="textarea" :rows="2" :placeholder="$t('wholesaler.AfterSalesReturnPage.line154_placeholder')" maxlength="500" show-word-limit></el-input>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="bottom-actions">
      <el-button @click="goBack" style="flex:1;">{{ $t('common.cancel') }}</el-button>
      <el-button type="danger" @click="submitProcess" :loading="submitting" style="flex:2;">{{ $t('wholesaler.AfterSalesReturnPage.line162_text') }}</el-button>
    </div>
  </div>
</template>

<script>
import { getAfterSalesDetail, getAvailableWarehouses, processReturn } from '@/services/afterSales';
import { getImageUrl } from '@/utils/image';

export default {
  name: 'AfterSalesReturnPage',
  data() {
    return {
      loading: false,
      submitting: false,
      detail: {},
      returnItems: [],
      warehouses: [],
      form: {
        refundAmount: 0,
        refundNote: '',
        refundProofUrls: []
      },
      proofFileList: []
    };
  },
  computed: {
    evidenceList() {
      try { return this.detail.evidenceUrls ? JSON.parse(this.detail.evidenceUrls) : []; }
      catch { return []; }
    },
    restockCount() {
      return this.returnItems.filter(i => i.disposition === 'RESTOCK').length;
    },
    scrapCount() {
      return this.returnItems.filter(i => i.disposition === 'SCRAP').length;
    },
    maxRefundAmount() {
      // 不能超过审核时设定的金额
      return this.detail.refundAmount || 0;
    }
  },
  created() { this.loadDetail(); },
  methods: {
    getImageUrl,
    async loadDetail() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        this.detail = await getAfterSalesDetail(id);
        // 初始化退款金额
        this.form.refundAmount = this.detail.refundAmount || 0;
        // 加载已有凭证（如果之前上传过）
        if (this.detail.refundProofUrls) {
          try {
            const urls = JSON.parse(this.detail.refundProofUrls);
            this.form.refundProofUrls = urls;
            this.proofFileList = urls.map(url => ({ name: '凭证', url, status: 'success' }));
          } catch (e) { /* ignore */ }
        }

        // 加载仓库列表
        try {
          this.warehouses = await getAvailableWarehouses();
        } catch (e) {
          this.warehouses = [];
        }
        // ⭐ 手动添加「店铺仓库」（虚拟仓库，id=0），如果没有的话
        const hasShopWh = this.warehouses.some(w => w.id === 0);
        if (!hasShopWh) {
          this.warehouses.unshift({ id: 0, warehouseName: '店铺仓库', isDefault: false });
        }

        // 初始化退回商品列表
        if (this.detail.returnItems) {
          const items = JSON.parse(this.detail.returnItems);
          this.returnItems = items.map(item => ({
            productId: item.productId,
            productName: item.productName,
            quantity: item.quantity,
            disposition: 'RESTOCK',
            warehouseId: null,
            warehouseName: '',
            note: ''
          }));
        } else if (this.detail.applyItems) {
          const items = JSON.parse(this.detail.applyItems);
          this.returnItems = items.map(item => ({
            productId: item.productId || item.orderItemId,
            productName: item.productName,
            quantity: item.quantity,
            disposition: 'RESTOCK',
            warehouseId: null,
            warehouseName: '',
            note: ''
          }));
        }
      } catch (e) {
        this.$message.error('加载失败: ' + (e.message || e));
      } finally { this.loading = false; }
    },
    goBack() { this.$router.back(); },
    reasonText(code) {
      const m = { DAMAGED:'商品破损', WRONG_ITEM:'发错货了', NOT_RECEIVED:'没收到货', WRONG_SPEC:'规格不对', SHORT_DELIVERY:'少发了', DONT_WANT:'不想要了', OTHER:'其他' };
      return m[code] || code;
    },
    schemeText(type) {
      const m = { RETURN_REFUND:'退货退款', EXCHANGE:'换货', RESEND:'补发', PARTIAL_REFUND:'部分退款', RELIEF:'减免', NO_ACTION:'不处理' };
      return m[type] || type;
    },
    statusText(s) {
      const m = { AWAITING_RETURN:'待处理退货', RETURN_RECEIVED:'已收到退货', INSPECTING:'质检中' };
      return m[s] || s;
    },
    statusTagType(s) {
      const m = { AWAITING_RETURN:'warning', RETURN_RECEIVED:'info', INSPECTING:'warning' };
      return m[s] || 'info';
    },
    centsToAmount(c) { if (!c && c !== 0) return '0.00'; return (c / 100).toFixed(2); },
    beforeProofUpload(file) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) this.$message.error('只能上传图片文件');
      return isImage;
    },
    handleProofUpload(response, file) {
      if (response && response.url) {
        this.form.refundProofUrls.push(response.url);
        this.proofFileList.push({ name: file.name, url: response.url, status: 'success' });
      }
    },
    handleProofRemove(file) {
      const url = file.url || file.response?.url;
      const idx = this.form.refundProofUrls.indexOf(url);
      if (idx > -1) this.form.refundProofUrls.splice(idx, 1);
    },
    async submitProcess() {
      // 校验：所有商品都选择了处理方式
      for (const item of this.returnItems) {
        if (!item.disposition) {
          this.$message.warning(`请为「${item.productName}」选择处理方式`);
          return;
        }
        if (item.disposition === 'RESTOCK' && (item.warehouseId === null || item.warehouseId === undefined)) {
          this.$message.warning(`请为「${item.productName}」选择还回仓库`);
          return;
        }
      }
      // 校验退款金额
      if (this.form.refundAmount > this.maxRefundAmount) {
        this.$message.warning('退款金额不能超过审核时设定的金额');
        return;
      }

      this.$confirm('确认提交？退货处理完成后将直接完成退款，此操作不可撤销', '确认处理', {
        confirmButtonText: '确认提交',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.submitting = true;
        try {
          // 构建处理明细
          const dispositions = this.returnItems.map(item => {
            const wh = this.warehouses.find(w => w.id === item.warehouseId);
            return {
              productId: item.productId,
              productName: item.productName,
              quantity: item.quantity,
              disposition: item.disposition,
              warehouseId: item.disposition === 'RESTOCK' ? item.warehouseId : null,
              warehouseName: wh ? wh.warehouseName : null
            };
          });

          await processReturn(this.detail.id, {
            refundAmount: this.form.refundAmount,
            refundProofUrls: this.form.refundProofUrls.length > 0 ? JSON.stringify(this.form.refundProofUrls) : null,
            refundNote: this.form.refundNote,
            dispositions: dispositions
          });

          this.$message.success('退货处理完成，退款已执行');
          this.$router.push(`/wholesaler/after-sales/${this.detail.id}`);
        } catch (e) {
          this.$message.error('处理失败: ' + (e.message || e));
        } finally { this.submitting = false; }
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.page-header { background: linear-gradient(135deg, #d46b08, #fa8c16); color: #fff; padding: calc(16px + env(safe-area-inset-top, 0px)); }
.back-btn { font-size: 12px; opacity: 0.8; cursor: pointer; margin-bottom: 4px; }
.back-btn:hover { opacity: 1; }
.page-header h1 { font-size: 17px; }
.page-header .sub { font-size: 12px; opacity: 0.8; }

.content { max-width: 600px; margin: 0 auto; padding-bottom: 60px; background: #f5f5f5; min-height: calc(100vh - 80px); }

.module { margin: 8px; background: #fff; border-radius: 8px; overflow: hidden; }
.module-header { display: flex; align-items: center; padding: 12px 12px 8px; gap: 6px; border-bottom: 1px solid #f0f0f0; }
.module-header .icon { font-size: 16px; }
.module-header .title { font-size: 14px; font-weight: 600; flex: 1; }
.module-body { padding: 12px; }

.row { display: flex; justify-content: space-between; padding: 8px 0; font-size: 13px; }
.row .label { color: #999; }
.row .value { font-weight: 500; text-align: right; }
.row .value.mono { font-family: monospace; font-size: 12px; }
.row .value.amount { color: #ff4d4f; font-size: 15px; font-weight: 700; }
.row + .row { border-top: 1px dashed #f0f0f0; }

/* 退回商品卡片 */
.return-item-card { padding: 12px; border: 1px solid #f0f0f0; border-radius: 6px; margin-bottom: 10px; }
.ri-header { display: flex; justify-content: space-between; margin-bottom: 8px; }
.ri-name { font-size: 14px; font-weight: 600; }
.ri-qty { font-size: 12px; color: #999; }
.ri-label { font-size: 12px; color: #666; margin-right: 4px; }

/* 汇总 */
.summary-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
.summary-item { text-align: center; padding: 12px; border-radius: 6px; }
.summary-item.green { background: #f6ffed; }
.summary-item.green .s-num { color: #52c41a; }
.summary-item.red { background: #fff2f0; }
.summary-item.red .s-num { color: #ff4d4f; }
.s-num { font-size: 24px; font-weight: 700; }
.s-label { font-size: 11px; color: #999; margin-top: 2px; }

.evidence-grid { display: flex; gap: 8px; flex-wrap: wrap; }
.evidence-img { width: 80px; height: 80px; border-radius: 6px; }

.bottom-actions { position: sticky; bottom: 0; background: #fff; border-top: 1px solid #e8e8e8; padding: 12px; display: flex; gap: 8px; }
</style>
